import React from 'react'
import LogoCa from 'images/spa/top/logo/logo_ca.png'
import LogoMixi from 'images/spa/top/logo/logo_mixi.png'
import LogoAkatsuki from 'images/spa/top/logo/logo_akatsuki.png'
import LogoDataX from 'images/spa/top/logo/logo_datax.png'
import LogoRhizome from 'images/spa/top/logo/logo_rhizome.png'
import LogoDdd from 'images/spa/top/logo/logo_ddd.png'
import LogoSuperStudio from 'images/spa/top/logo/logo_superstudio.png'
import LogoGoertek from 'images/spa/top/logo/logo_goertek.png'
import LogoStylePort from 'images/spa/top/logo/logo_styleport.png'
import LogoSal from 'images/spa/top/logo/logo_sal.png'
import LogoCaradamedica from 'images/spa/top/logo/logo_caradamedica.png'
import LogoLcl from 'images/spa/top/logo/logo_lcl.png'
import LogoPamlocalmedia from 'images/spa/top/logo/logo_pamlocalmedia.png'
import LogoRex from 'images/spa/top/logo/logo_rex.png'
import LogoAttack from 'images/spa/top/logo/logo_attack.png'
import LogoHanda from 'images/spa/top/logo/logo_handa.png'
import LogoAdish from 'images/spa/top/logo/logo_adish.png'
import LogoTrustRidge from 'images/spa/top/logo/logo_trustridge.png'
import LogoFarmNote from 'images/spa/top/logo/logo_farmnote.png'
import LogoReivo from 'images/spa/top/logo/logo_reivo.png'
import LogoIncubationcode from 'images/spa/top/logo/logo_incubationcode.png'
import LogoGeekfeed from 'images/spa/top/logo/logo_geekfeed.png'
import LogoLisb from 'images/spa/top/logo/logo_lisb.png'
import LogoMicin from 'images/spa/top/logo/logo_micin.png'
import LogoUnifa from 'images/spa/top/logo/logo_unifa.png'
import LogoNaviplus from 'images/spa/top/logo/logo_naviplus.png'
import LogoAtrae from 'images/spa/top/logo/logo_atrae.png'
import LogoFinc from 'images/spa/top/logo/logo_finc.png'
import LogoLivesense from 'images/spa/top/logo/logo_livesense.png'
import LogoMonopos from 'images/spa/top/logo/logo_monopos.png'

import { StyledBrandSlider } from './styled'

export const Logos = [
  { src: LogoCa, alt: '株式会社サイバーエージェント', width: 81 },
  { src: LogoMixi, alt: '株式会社MIXI', width: 104 },
  { src: LogoAkatsuki, alt: '株式会社アカツキ', width: 151 },
  { src: LogoDataX, alt: '株式会社データX', width: 163 },
  { src: LogoRhizome, alt: '株式会社リゾーム', width: 160 },
  { src: LogoDdd, alt: '株式会社スリーディー', width: 211 },
  { src: LogoSuperStudio, alt: '株式会社SUPER STUDIO', width: 160 },
  { src: LogoGoertek, alt: 'Goertek Technology Japan株式会社', width: 168 },
  { src: LogoStylePort, alt: '株式会社スタイルポート', width: 205 },
  { src: LogoSal, alt: '株式会社SAL', width: 117 },
  { src: LogoCaradamedica, alt: '株式会社カラダメディカ', width: 256 },
  { src: LogoLcl, alt: '株式会社LCL', width: 117 },
  { src: LogoPamlocalmedia, alt: '株式会社パムローカルメディア', width: 111 },
  { src: LogoRex, alt: '株式会社レックスアドバイザーズ', width: 106 },
  { src: LogoAttack, alt: 'Attack株式会社', width: 211 },
  { src: LogoHanda, alt: '半田重工業株式会社', width: 249 },
  { src: LogoAdish, alt: 'アディッシュ株式会社', width: 94 },
  { src: LogoTrustRidge, alt: '株式会社トラストリッジ', width: 207 },
  { src: LogoFarmNote, alt: '株式会社ファームノート', width: 225 },
  { src: LogoReivo, alt: 'リーボ株式会社', width: 151 },
  { src: LogoIncubationcode, alt: '株式会社IncubationCode', width: 147 },
  { src: LogoGeekfeed, alt: '株式会社ギークフィード', width: 235 },
  { src: LogoLisb, alt: '株式会社L is B', width: 96 },
  { src: LogoMicin, alt: '株式会社MICIN', width: 160 },
  { src: LogoUnifa, alt: 'ユニファ株式会社', width: 190 },
  { src: LogoNaviplus, alt: 'ナビプラス株式会社', width: 228 },
  { src: LogoAtrae, alt: '株式会社アトラエ', width: 139 },
  { src: LogoFinc, alt: '株式会社FiNC Technologies', width: 106 },
  { src: LogoLivesense, alt: '株式会社リブセンス', width: 172 },
  { src: LogoMonopos, alt: '株式会社Monopos', width: 151 }
]

export const BrandSlider: React.FC = () => {
  return <StyledBrandSlider logos={Logos} />
}
